import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { getSettingByKey } from "../../services/settingsService";
import RadarImageModal from "../modals/Image/RadarImageModal";
import { useAuth } from "../../contexts/AuthContextProvider";

export default function RadarCard() {
	const { user } = useAuth();
	const [link, setLink] = useState(null);
	const [count, setCount] = useState(1);
	const [loading, setLoading] = useState(true);
	const [showModal, setShowModal] = useState(false);
	const [modalImage, setModalImage] = useState(null);

	useEffect(() => {
		getSettingByKey("radarLink").then((res) => setLink(res.data.value));
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setCount((prev) => (prev === 19 ? 1 : prev + 1));
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	const handleClick = () => {
		if (!user) return;
		setShowModal(true);
		const API_URL = process.env.REACT_APP_API_BASE_URL;
		setModalImage(`${API_URL}/proxy/image/${count}`);
	};

	const handleImageLoad = () => {
		setLoading(false);
	};

	if (!link)
		return (
			<div className="p-4 flex flex-col items-center h-full">
				<div className="w-full h-full max-w-xl">
					<Skeleton height={"100%"} />
				</div>
			</div>
		);

	return (
		<>
			{loading && (
				<div className="p-4 flex flex-col items-center max-h-[400px] h-[100%]">
					<div className="w-full h-full max-w-xl">
						<Skeleton height={"100%"} />
					</div>
				</div>
			)}

			<div className="flex justify-center items-center h-[100%] relative">
				{/* Immagine radar */}
				<img
					className={`w-full h-full object-contain aspect-square max-h-[400px] ${
						loading ? "hidden" : "block"
					}`}
					src={`${link}/ultimo.${count}.png`}
					alt={`Radar ${count}`}
					onLoad={handleImageLoad}
					onClick={handleClick}
				/>
			</div>
			{showModal && (
				<RadarImageModal
					link={modalImage}
					onClose={() => {
						setShowModal(false);
						setModalImage(null);
					}}
				/>
			)}
		</>
	);
}
